import { render } from "./PressCard.vue?vue&type=template&id=58c2b846"
import script from "./PressCard.vue?vue&type=script&lang=js"
export * from "./PressCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__